import { CustomInputItem } from '../../../component/option/custom-input-item/CustomInputItem';
import { CustomInputProps } from '../../../type/common.type';

interface CustomInputSectionProps {
  display: boolean;
  data: CustomInputProps[];
}

export const CustomInputSection = ({ display, data }: CustomInputSectionProps) => {
  if (!display) {
    return null;
  }

  return (
    <>
      {data.map((data, index) => (
        <CustomInputItem key={`${data.name}-${index}`} {...data} />
      ))}
    </>
  );
};
